<script>
import gql from 'graphql-tag'
import BaseLayout from '@/components/shared/layout/BaseLayout'
import platformDetect from '@/mixins/platformDetect'
import axios from 'axios'
export default {
  name: 'InfoShow',
  props: {
    id: { required: true },
    from: {required: false},
    titre: {required: false},
    image: {require: false},
    description: {require: false},
  },
  data () {
    return {
      container: null,
      link: null,
      valvid: '',
      thumbnail: '',
      open: false,
      stripDesc: '',
      url: '',
    }
  },
  created () {
    // alert('on cree la page')
    // this.$on('okHead', function () {
    //   console.log('test')
    // })
  },
  // head: {
  //   title: function () {
  //     return {
  //       inner: this.titre,
  //     }
  //   },
  //   meta: function () {
  //     console.log('on arrive')
  //     console.log(this.titre)
  //     console.log(this.image)
  //     var temp = this.description
  //     temp = temp.replace(/<br>/gi, '\n')
  //     temp = temp.replace(/<p.*>/gi, '\n')
  //     temp = temp.replace(/<a.*href="(.*?)".*>(.*?)<\/a>/gi, ' $2 (Link->$1) ')
  //     this.stripDesc = temp.replace(/<(?:.|\s)*?>/g, '')
  //     this.stripDesc = this.stripDesc.substr(0, 50)
  //     console.log(this.stripDesc)
  //     this.url = 'http://experience.dreamingofajewishchristmas.com/pages#' + this.$route.fullPath
  //     console.log(this.url)
  //     return [
  //       { name: 'description', content: this.stripDesc },
  //       { property: 'og:url', content: this.url },
  //       { property: 'og:type', content: 'article' },
  //       { property: 'og:title', content: this.titre, id: 'fb-title' },
  //       { property: 'og:description', content: this.stripDesc, id: 'fb-desc' },
  //       /*eslint-disable*/
  //       { property: 'og:image', content: '~@/assets/imgs_bg/fond10.jpg' },
  //       /*eslint-enable*/
  //     ]
  //   },
  // },
  mixins: [
    platformDetect,
    // getUsagerStatistiques,
  ],
  apollo: {
    container: {
      /*eslint-disable*/
      query: gql `query container($id: String!){
        container(id: $id){
          id categorie_list description titre medias{
            id position image{titre url description thumbnail} mediable_id mediable_type video{titre link minutage description url}
          }
        }
      }`,
      variables () {
        return { id: this.id }
      },
      skip () { return !this.id },
      fetchPolicy: 'cache-first',
      update: data => data.container,
      /*eslint-enable*/
      loadingKey: 'loading',
      watchLoading (isLoading, countModifier) {
      // isLoading is a boolean
      // countModifier is either 1 or -1
        // console.log('EN CHARGEMENT', isLoading)
      },
    },
  },
  components: {
    BaseLayout,
  },
  methods: {
    getVid: function (url) {
      if (url.includes('youtube')) {
        var link = url.replace(/(<([^>]+)>)/ig, '')
          /* eslint-disable */
        var re = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=)?([\w\-]{10,12})(?:&feature)?(?:[\w\-]{0})?/g
        var iframe = 'https://www.youtube.com/embed/$1'
          /* eslint-enable */
        link = iframe.replace('$1', link.split(re)[1])
        // console.log(link)
        return link
      } else {
        // axios.get('https://vimeo.com/api/oembed.json?url=' + url).then(function (response) {
        //   // console.log(response.data)
        //   var temp = response.data
        //   // console.log(temp)
        //   console.log('test')
        //   console.log(temp)
        //   console.log(temp.html)
        //   this.valvid = temp.html
        //   return temp.html
        // })
      }
    },
    async getHTML (url) {
      // console.log('test')
      var h = Math.round(document.documentElement.clientHeight * 0.3)
      var w = Math.round(document.documentElement.clientWidth * 0.72)
      try {
        /*eslint-disable*/
        var temp = await axios.get('https://vimeo.com/api/oembed.json?url=' + url + '&width='+ w +'&height=' + h )
        /*eslint-enable*/
      } finally {
        console.log(temp.data.thumbnail_url_with_play_button)
        console.log(temp.data.html)
        this.valvid = temp.data.html
        this.thumbnail = temp.data.thumbnail_url_with_play_button
      }
    },
    isVimeo: function (url) {
      if (url.includes('vimeo')) {
        this.getHTML(url)
        return true
      } else {
        return false
      }
    },
  },
}
</script>
<template lang="pug">
base-layout
  div.backgroundtexturefilm(v-if="from === 'film'")
  div.backgroundtexture(v-else)
  //- div.backgroundimg
  div.info-show(v-if='container')
    q-btn.fixed-bottom-right.animate-pop(v-back-to-top.animate='{offset: 500, duration: 200}', round='', color='negative', style='margin: 0 30px 30px 0')
      i.fa.fa-caret-up.fa-2x.white

    div.bloctitre {{container.titre}}
    div.soustitre(v-for="med in container.medias")
      div.conteneurimages(v-if="med.image")
        img.mb1(:src="med.image.thumbnail")
        //- img(v-if="med.image", :src="med.image.url")
        p(v-html='med.image.description')
    div.soustitre(v-if='from === true',v-for="med in container.medias")
      div(v-if="med.video")
        div(v-if="isVimeo(med.video.link)")
          div(v-html='valvid')
        div(v-else)
          q-video(:src='getVid(med.video.link)', style="height: 300px;")
          p.mt2 {{med.video.titre}}
      div.blocdescription(v-html="container.description")
    div.blocdescription(v-else)
      div(v-if="container.medias[0].video && container.medias[0].video.titre === 'DoaJC Teaser'")
        div.soustitre(v-for="med in container.medias")
          div(v-if="med.video")
            div(v-if="isVimeo(med.video.link)")
              div(v-html='valvid')
            div(v-else)
              q-video(:src='getVid(med.video.link)', style="height: 300px;")
              p.mt2 {{med.video.titre}}
      div(v-html="container.description")
        div.soustitre(v-for="med in container.medias")
          div(v-if="med.video")
            div(v-if="isVimeo(med.video.link)")
              div(v-html='valvid')
            div(v-else)
              q-video(:src='getVid(med.video.link)', style="height: 300px;")
              p.mt2 {{med.video.titre}}
        //- div.soustitre(v-html='med.video.description')
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
/*ANIMATION*/
.about{
  -moz-animation: fadeInDown 2;
  -webkit-animation: fadeInDown 2s;
  animation: fadeInDown 2s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
.backgroundimg{
  -moz-animation: fadeInDown 2;
  -webkit-animation: fadeInDown 2s;
  animation: fadeInDown 2s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}

/*ANIMATION END*/

/*mobile*/
.layout-page-container{
  height: 100% !important;
}
@media screen and (min-width: 320px){
  .backgroundtexture{
  background-image: url('~@/assets/JWWC-SET-6_dark_light.jpg');
  background-size: cover;
  height: 100vh!important;
  width:100vw!important;
  z-index:-10;
  position:fixed;
  }
  .backgroundtexturefilm{
  background-image: url('~@/assets/imgs_bg/fond10.jpg');
  background-size: cover;
  height: 100vh!important;
  width:100vw!important;
  z-index:-10;
  position:fixed;
  }
  .info-show {
  padding: 70px 35px 40px 35px;
    & .bloctitre {
      /*width: ;*/
      font-family: Abril Fatface;
      font-size: 28px;
      margin: 0 auto 20px;
      text-transform: uppercase;
      line-height:40px;
      /*background-color: red;*/
      color:white;
      padding: 20px 20px 20px 20px;
      border-style: double;
      border-width: 10px;
      border-color:white;
    }
  }
  img{
    p{
      color:red !important;
    }
  }
  h1 {
    color: white;
    font-family: Abril Fatface;
    font-size: 30px;
    margin-top: 10px;
    margin-bottom:10px;
  }
  .soustitre{
    color:white;
    /*font-style: italic;*/
    text-align: center;
    font-size:12px;
    margin:0 auto;

    & .conteneurimages{
      & img{
        max-height:500px;
      }
    }
  }
  .blocdescription{
    padding: 0 20px 0 20px;
    & h1.blocdescription{
      color: white;
      font-family: Abril Fatface;
      font-size: 30px;
      margin-top: 10px;
      margin-bottom:10px;
    }
    & h1{
      color: white;
      font-family: Abril Fatface;
      font-size: 30px;
      text-align: left;
      /*margin-top: 40px;*/
      margin-bottom:10px;
    }
    & h2 {
      /*font-family: MarketDeco;*/
      font-size: 26px;
      color:white;
      text-align: left;
      font-family: Crimson Text;
      font-style: italic;
      padding-top:10px;
      line-height: 30px;
    }
    & strong{
      font-weight: bold;
    }
    & h3{
      font-size:24px !important;
      font-style: italic;
      color: white;
      font-weight: bold;
      border-bottom: 1px solid red;
      margin-bottom: 10px;
      padding-bottom: 10px;
      font-family: Crimson text;

    }
    & h4{
      font-size: 15px;
      margin-top:10px;
      color:white;
      text-align: left;
      /*margin:0 !important;*/
      margin-bottom:20px !important;

      }
    & h4 em{
      color:white;
      font-style: italic;
      /*font-weight: bold;*/
      font-family: Crimson text;
      font-size: 18px;
      line-height:20px;
    }
    & h5{
      background-color:white;
      border-left: 4px red solid;
      border-radius: 8px;
      color:black;
      max-width:500px;
      padding:20px;
      font-style: italic;
      text-align: left;
      font-size:15px;
      line-height: 20px;
      box-shadow:0 4px 8px 0 rgba(0, 0, 0, 0.2);
    }
    & p {
      font-size: 19px;
      color:white;
      /*text-shadow: 1px 1px 2px rgba(0, 0, 0, 1);*/
      margin-top: 22px;
      margin-bottom: 22px;
      line-height: 24px;
      text-align: left;
      text-indent: 22px;
      font-family: Crimson text;
    }
    & p.exergue {
      text-indent:0px;
      font-size: 15px;
      font-style: italic;
      line-height: 20px;
      padding: 5px 10px 5px 10px;
      border-left-width: 4px;
      border-left-color: red;
      border-left-style: solid;
      background-color: white;
      width:80%;
      margin: 20px auto 20px;
    }
    & .serving{
      margin: 20px;
      text-align: center!important;
      color:white
    }
    & .time{
      margin: 20px;
      text-align: center!important;
      color:white
    }
    & .serving:before{
      font-family: FontAwesome;
      content: "\f0c0";
      color: red;
      margin-right: 8px;
    }
    & .time:before{
      font-family: FontAwesome;
      content: "\f017";
      color: red;
      margin-right: 8px;
    }
    & .reference{
      text-align: center!important;
      font-style: italic;
    }

    & ul {
      color: white;
      list-style-type: disc;
      text-align: left;
      font-size: 18px;
      text-shadow: 1px 1px 2px rgba(0, 0, 0, 1);
      margin-top: 20px;
      margin-bottom:40px;
      width: 100%;
      border-bottom: 1px solid red;
      padding-bottom: 20px;
    }
    & ul li {
      margin: 0 0 10px;
      text-align: left;
      text-shadow: 1px 1px 2px rgba(0, 0, 0, 1);
      line-height: 22px;
    }
    & ol {
      counter-reset: item;
      text-align: left;
      font-size: 18px;
      margin-top: 20px;
      width: 100%;
    }
    & ol li {
      display: block;
      color:white;
      margin: 0 0 20px 0;
      text-align: left;
      line-height: 25px;
      font-size: 20px;
      font-family: crimson text;
      text-indent:-45px;
      list-style-type:none;
      counter-increment:item;
    }
    & ol li:before {
      display:inline-block;
      width:1.5em;
      padding-right:0.5em;
      font-weight:bold;
      font-size: 30px;
      text-align:right;
      content:counter(item) ".";
    }
    & a {
      color: #42b983;
    }
    & .soustitre{
      & p {
        margin: 5px 0 10px 10%;
        font-size: 15px;
        line-height: 18px;
        text-align: left;
        font-style:italic;
      }
      & p em {
        font-size: 15px;
        font-style: italic;
        line-height: 18px;
      }
    }
  }
}
@media only screen and (min-width: 320px) and (max-width: 767px) and (orientation:landscape) {

  .info-show {
    padding: 70px 35px 40px 35px;

    width: 80%;
    margin: 0 auto;
  /*margin-top: 75px;*/
    & .bloctitre {
      font-family: Abril Fatface;
      font-size: 35px;
      margin: 20px auto 20px;
      /*background-color: red;*/
      padding: 30px 30px 30px 30px;
      border-style: double;
      border-width: 10px;
      color:white;
      border-color:white;

    }
    & .blocdescription{
    /*background-color: pink;*/
    }
  }
}


/*TABLET*/

@media only screen and (min-width: 768px){

  .info-show {
    padding: 70px 35px 40px 35px;

    width: 85%;
    top: 60px;
    margin: 0 auto;
    & .bloctitre {
      font-family: Abril Fatface;
      font-size: 35px;
      width:500px !important;
      margin: 20px auto 20px;
      /*background-color: red;*/
      padding: 30px 30px 30px 30px;
      border-style: double;
      border-width: 10px;
      color:white;
      border-color:white;
    }
    & .blocdescription{

      padding: 0 20px 0 20px;
      width:600px;
      margin: 0 auto;
    }
  }
}
@media only screen and (min-width: 768px) and (max-width:960px) and (orientation:landscape) {
  .info-show {
    width: 75%;
    top: 60px;
    margin: 0 auto;
  }
}
@media only screen and (min-width: 961px){

  .info-show {
    & .bloctitre {
      font-family: Abril Fatface;
      font-size: 35px;
      width:500px;
      margin: 20px auto 20px;
      /*background-color: red;*/
      padding: 30px 30px 30px 30px;
      border-style: double;
      border-width: 10px;
      color:white;
      border-color:white;
    }
    & .blocdescription{
      padding: 0 20px 0 20px;
      width:700px;
      margin: 0 auto;
    }
  }
}
@media (min-width:320px)  { /* smartphones, iPhone, portrait 480x320 phones */ }
@media (min-width:481px)  { /* portrait e-readers (Nook/Kindle), smaller tablets @ 600 or @ 640 wide. */ }
@media (min-width:641px)  { /* portrait tablets, portrait iPad, landscape e-readers, landscape 800x480 or 854x480 phones */ }
@media (min-width:961px)  { /* tablet, landscape iPad, lo-res laptops ands desktops */ }
@media (min-width:1025px) { /* big landscape tablets, laptops, and desktops */ }
@media (min-width:1281px) { /* hi-res laptops and desktops */ }

</style>



// WEBPACK FOOTER //
// InfoShow.vue?984b238a